import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BehaviorSubject, Observable } from "rxjs";
import { Utils } from "../../../utils/utils";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class VirtualTourService {
  constructor(private readonly _http: HttpClient) {}

  isOnTour = new BehaviorSubject<boolean>(false);

  flagTourAsDone(): Observable<any> {
    const headers = Utils.generateDefaultHeader();
    return this._http.patch(
      `${environment.logonPortalBaseUrl}/user-accounts/me`,
      {
        virtualTour: {
          enabled: false,
        },
      },
      { headers },
    );
  }
}
